module.exports = __webpack_public_path__ + "static/media/cision_logo.62e4fbc9.svg";